<div class="asset-rule-builder" *ngIf="assetRules">
  <div class="asset-rule-builder__filters">
    <div class="asset-rule-builder__field">
      <label>1. Berichte auswählen</label>
      <div class="asset-rule-builder__choice-row">
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="isReportStatusSelected('FINALIZED')"
          (click)="toggleReportStatus('FINALIZED')">
          Finalisierte Berichte
        </button>
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="isReportStatusSelected('DRAFT')"
          (click)="toggleReportStatus('DRAFT')">
          Entwurfsberichte
        </button>
      </div>
      <div class="asset-rule-builder__hint">Ein Data Offer kann Entwürfe, finale Berichte oder beide Status enthalten.</div>
    </div>

    <div class="asset-rule-builder__field">
      <label>2. Zeitraum</label>
      <div class="asset-rule-builder__choice-row">
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="assetRules.datePreset === 'all'"
          (click)="selectDatePreset('all')">
          Alle Projekte
        </button>
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="assetRules.datePreset === 'current-month'"
          (click)="selectDatePreset('current-month')">
          Aktueller Monat
        </button>
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="assetRules.datePreset === 'last-30-days'"
          (click)="selectDatePreset('last-30-days')">
          Letzte 30 Tage
        </button>
        <button
          type="button"
          class="asset-choice"
          [class.is-active]="assetRules.datePreset === 'custom'"
          (click)="selectDatePreset('custom')">
          Benutzerdefiniert
        </button>
      </div>
      <div class="asset-rule-builder__date-grid" *ngIf="isCustomDateRange">
        <label class="asset-rule-builder__date-field">
          <span>Startdatum</span>
          <input
            class="asset-rule-builder__date-input"
            type="date"
            [ngModel]="assetRules.startDate"
            (ngModelChange)="updateStartDate($event)">
        </label>
        <label class="asset-rule-builder__date-field">
          <span>Enddatum</span>
          <input
            class="asset-rule-builder__date-input"
            type="date"
            [ngModel]="assetRules.endDate"
            (ngModelChange)="updateEndDate($event)">
        </label>
      </div>
    </div>
  </div>

  <div class="asset-section-selector">
    <div class="asset-section-selector__header">
      <div>
        <strong>3. Abschnitte im Data Offer</strong>
        <p>Wählen Sie alle logischen Abschnitte aus, die dieses Angebot enthält.</p>
      </div>
      <div class="asset-section-selector__actions">
        <button mat-stroked-button type="button" (click)="clearAllSections()">Keine Auswahl</button>
        <button mat-stroked-button type="button" (click)="clearExternalSections()">Standardauswahl</button>
        <button mat-stroked-button color="primary" type="button" (click)="selectAllSections()">Alle Abschnitte</button>
      </div>
    </div>

    <div class="asset-section-groups">
      <div class="asset-section-group" *ngFor="let group of groupedSectionOptions">
        <div class="asset-section-group__title">
          <mat-checkbox
            [checked]="isGroupSelected(group.title)"
            [indeterminate]="isGroupIndeterminate(group.title)"
            (change)="toggleGroup(group.title)">
            {{ group.title }}
          </mat-checkbox>
        </div>
        <div class="asset-section-group__items">
          <button
            type="button"
            class="asset-section-item"
            *ngFor="let section of group.items"
            [class.is-selected]="isSectionSelected(section.id)"
            [class.is-internal]="section.group === 'Intern'"
            (click)="toggleSection(section.id)">
            <span class="asset-section-item__label">{{ section.label }}</span>
            <span class="asset-section-item__description">{{ section.description }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="asset-preview-hint">
    <mat-icon>info_outline</mat-icon>
    <span>Dieses Angebot beschreibt fachliche Datenregeln. Der Connector übersetzt sie später in die technische Control-Plane und Data-Plane Konfiguration.</span>
  </div>
</div>
